<template>
  <span v-if="maxHr" class="text-small ml-1 label-hr-max"
    >{{ $t('src/components/patientmaxhr.7310') }}<sub>max</sub> = {{ maxHr }} {{ $t('unit.bpm') }}</span
  >
</template>

<script>
import { patientMaxHR } from '@/mixins/patient-max-hr'

export default {
  name: 'PatientMaxHr',
  mixins: [patientMaxHR],
  props: {
    patient: {
      type: Object,
      required: true
    }
  }
}
</script>
